import React, { useState } from "react";
import ColorInput from "./ColorInput";
import TextInput from "./TextInput";
import NumberInput from "./NumberInput";
import { validateButtonWidth, validateColor, validateText } from "./fieldValidation";

export default function SubscribeBoxInput({ onInsert }) {
  const [data, setData] = useState({
    title: "Get productivity tips delivered straight to your inbox",
    titleFontSize: 24,
    description: "We'll email you 1-3 times per week and never share your information",
    descriptionFontSize: 16,
    textBoxWidth: 30,
    buttonText: "Subscribe",
    buttonColor: "#086BE5",
    buttonTextColor: "#FFFFFF",
    buttonBorderColor: "#086BE5",
    buttonWidth: 20,
  });

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();

        onInsert(data);
      }}
      css={{
        width: 300,
        padding: 8,
        display: "grid",
        gridRowGap: 8,
      }}
    >
      <TextInput
        fieldName="title"
        label="Title"
        placeholder="Type title..."
        data={data}
        setData={setData}
        required={true}
      />
      <NumberInput
        fieldName="titleFontSize"
        label="Title font size"
        data={data}
        setData={setData}
        required={true}
        minValue={4}
        maxValue={64}
      />
      <TextInput
        fieldName="description"
        label="Description"
        placeholder="Type description..."
        data={data}
        setData={setData}
      />
      <NumberInput
        fieldName="descriptionFontSize"
        label="Description font size"
        data={data}
        setData={setData}
        required={true}
        minValue={4}
        maxValue={64}
      />
      <TextInput
        fieldName="buttonText"
        label="Button Text"
        placeholder="Type button text..."
        data={data}
        setData={setData}
        required={true}
      />
      <ColorInput
        fieldName="buttonColor"
        label="Button Color"
        placeholder="Type button color..."
        data={data}
        setData={setData}
        required={true}
      />
      <ColorInput
        fieldName="buttonTextColor"
        label="Button Text Color"
        placeholder="Type button text color..."
        data={data}
        setData={setData}
        required={true}
      />
      <ColorInput
        fieldName="buttonBorderColor"
        label="Button Border Color"
        placeholder="Type button border color..."
        data={data}
        setData={setData}
        required={true}
      />
      <NumberInput fieldName="textBoxWidth" label="Text width %" data={data} setData={setData} required={true} />
      <NumberInput fieldName="buttonWidth" label="Button width %" data={data} setData={setData} required={true} />

      <button
        type="submit"
        disabled={!validateForm(data)}
        css={{
          margin: 0,
          padding: 8,
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
        }}
      >
        Insert
      </button>
    </form>
  );
}

function validateForm(data) {
  return (
    validateText(data.title) &&
    validateButtonWidth(data.textBoxWidth) &&
    validateText(data.buttonText) &&
    validateColor(data.buttonColor) &&
    validateColor(data.buttonTextColor) &&
    validateColor(data.buttonBorderColor) &&
    validateButtonWidth(data.buttonWidth)
  );
}
